<template>
    <div v-if='user'>
        <div v-if="!user.get('roles').includes('guest')">
            <va-row :gutter="32" style="padding-bottom: 70px; margin-top: 30px">
                <va-column
                    v-if="user.get('roles').includes('admin') || user.get('roles').includes('manager') || user.get('roles').includes('survey-editor') || user.get('roles').includes('survey-approver')  || user.get('roles').includes('submission-approver') || user.get('roles').includes('submitter')"
                    :lg="6" :md="6" :sm="12" :xs="12">
                    <h4 class="approvalHead" :class="{rtlHead: getSystemLanguage != 'english'}"
                        style="margin-left:14px; border-bottom:2px solid #07f7 !important;">
                        <span class="headContent">{{ _("Activities")}}</span>
                    </h4>

                    <div v-if="user.get('type') != 'guest'" class="activity_main_wrapper">
                        <activities />
                    </div>
                </va-column>
                <va-column
                    v-if="!user.get('roles').includes('survey-approver') && !user.get('roles').includes('survey-editor') && (user.get('roles').includes('submitter') || user.get('roles').includes('admin') || user.get('roles').includes('manager'))"
                    :lg="6" :md="6" :sm="12" :xs="12">
                    <h4 class="approvalHead" :class="{rtlHead: getSystemLanguage != 'english'}">
                        <span class="headContent">{{ _("Your Surveys")}}</span>
                        <!-- <span class="headContent" v-else>{{ _("Needs Approval")}}</span> -->
                    </h4>
                    <div>
                        <va-table hover fullWidth class="datatable approvalTable">
                            <table :dir="getDirectionStatus">
                                <thead>
                                    <tr>
                                        <th :class="{rtlTableHead: getSystemLanguage != 'english'}">{{ _('Name') }}</th>
                                        <th :class="{rtlTableHead: getSystemLanguage != 'english'}">{{ _('Category') }}
                                        </th>
                                        <th :class="{rtlTableHead: getSystemLanguage != 'english'}">{{ _('Created By')
                                                    }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="survey in allSurveysThatNeedsMyApproval"
                                        v-if="allSurveysThatNeedsMyApprovalCount != 0 && survey.get('category')!=null "
                                        style="cursor: pointer">
                                        <td :class="{rtlTd: getSystemLanguage != 'english'}">
                                            <a v-if="user.get('roles').length == 2 && user.get('roles').includes('surveys') && user.get('roles').includes('submitter')"
                                                style="cursor:pointer" @click="navigate(getRoute(survey))">{{
                                                        g_getLabel(survey) }}</a>
                                            <a v-else style="cursor:pointer" @click="navigate(getRoute(survey))">{{
                                                            g_getLabel(survey) }}</a>
                                        </td>
                                        <td>{{ g_getLabel(survey.get('category')) }}</td>
                                        <td>
                                            <va-tooltip v-if="survey.get('createdBy')"
                                                :content="survey.get('createdBy').get('name')" trigger="hover"
                                                placement="top">
                                                <img width="30px" height="30px"
                                                    style="display:inline-block;  border-radius: 100px; border:1px solid #fff;"
                                                    :src="survey.get('createdBy').get('profilePic').replace('https://parse.nepa.gov.af/parse/files/nepa/', 'https://parse.nepa.gov.af/parse/files/nepa/thumbnail_')" />
                                            </va-tooltip>
                                        </td>
                                        </td>
                                    </tr>

                                    <tr v-if="allSurveysThatNeedsMyApprovalCount == 0">
                                        <td :class="{rtlTd: getSystemLanguage != 'english'}" :colspan="6"
                                            style="text-align: center">
                                            {{ _("No surveys") }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </va-table>
                    </div>
                </va-column>

                <!-- for submission approver -->

                <va-column :lg="6" :md="6" :sm="12" :xs="12"
                    v-if="!user.get('roles').includes('survey-editor') && !user.get('roles').includes('survey-approver') && user.get('roles').includes('submission-approver')">
                    <h4 class="approvalHead" :class="{rtlHead: getSystemLanguage != 'english'}">
                        <span class="headContent">{{ _("Needs Approval")}}</span>
                    </h4>
                    <div>
                        <va-table hover fullWidth class="datatable approvalTable">
                            <table :dir="getDirectionStatus">
                                <thead>
                                    <tr>
                                        <th :class="{rtlTableHead: getSystemLanguage != 'english'}">{{ _('Name') }}</th>
                                        <th :class="{rtlTableHead: getSystemLanguage != 'english'}">{{ _('Category') }}
                                        </th>
                                        <th :class="{rtlTableHead: getSystemLanguage != 'english'}">{{ _('Created By')
                                                    }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="survey in allPublishedSurveysThatNeedsMyApproval"
                                        v-if="allPublishedSurveysThatNeedsMyApprovalCount != 0 && survey.get('category')!=null "
                                        style="cursor: pointer">
                                        <td :class="{rtlTd: getSystemLanguage != 'english'}">
                                            <a style="cursor:pointer" @click="navigate(getRoute(survey))">{{
                                                            g_getLabel(survey) }}</a>
                                        </td>
                                        <td>{{ g_getLabel(survey.get('category')) }}</td>
                                        <td>
                                            <va-tooltip v-if="survey.get('createdBy')"
                                                :content="survey.get('createdBy').get('name')" trigger="hover"
                                                placement="top">
                                                <img width="30px" height="30px"
                                                    style="display:inline-block;  border-radius: 100px; border:1px solid #fff;"
                                                    :src="survey.get('createdBy').get('profilePic').replace('https://parse.nepa.gov.af/parse/files/nepa/', 'https://parse.nepa.gov.af/parse/files/nepa/thumbnail_')" />
                                            </va-tooltip>
                                        </td>
                                        </td>
                                    </tr>

                                    <tr v-if="allPublishedSurveysThatNeedsMyApprovalCount == 0">
                                        <td :class="{rtlTd: getSystemLanguage != 'english'}" :colspan="6"
                                            style="text-align: center">
                                            {{ _("No surveys") }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </va-table>
                    </div>
                </va-column>
            </va-row>
        </div>

        <div v-else>
            <survey-list />
        </div>
    </div>
</template>

<script>
    import Parse from "@/main.js"
    import { mapGetters, mapActions } from "vuex";
    import Activities from "../Activities.vue"
    import SurveyList from "./SurveyList.vue"
    export default {

        components: {
            Activities,
            SurveyList
        },

        data() {
            return {
                newCategory: '',
                newCategoryPashto: '',
                newCategoryDari: '',
                categoryScope: null,
                allSurveysThatNeedsMyApproval: [],
                allSurveysThatNeedsMyApprovalCount: null,
                loading: false,
                // new
                activities: [],

                allPublishedSurveysThatNeedsMyApprovalCount: null,
                allPublishedSurveysThatNeedsMyApproval: [],
            }
        },
        computed: {
            ...mapGetters(['getCurrentDepartment', 'user', 'getGlobalCategories', 'getSavedFilters', 'getDepartments',
                'getSelectedDashboardItem', 'getSystemLanguage', 'getDirectionStatus'
            ]),

        },
        methods: {
            ...mapActions(['sendNewNotification', 'fetchDepartmentLocalCategories', 'fetchDepartmentGlobalCategories',
                'setGlobalCategories', 'setDepartments', 'setLoading'
            ]),

            getRoute(survey) {
                let route
                if (this.user.get('roles').length == 2 && this.user.get('roles').includes('surveys') && this.user.get('roles').includes('submitter')) {
                    if (survey.get('category').get('department')) {

                        route = '/surveys/' + survey.get('category').get('department').get('slug') + '/' + survey.get('category').get('slug') + '/' + survey.get('class_name').slice(5) + '/list'
                    } else {
                        route = '/surveys/global/' + survey.get('category').get('slug') + '/' + survey.get('class_name').slice(5) + '/list'
                    }
                } else if (!this.user.get('roles').includes('survey-editor') && !this.user.get('roles').includes('survey-approver') && this.user.get('roles').includes('submission-approver')) {
                    if (survey.get('category').get('department')) {

                        route = '/surveys/' + survey.get('category').get('department').get('slug') + '/' + survey.get('category').get('slug') + '/' + survey.get('class_name').slice(5) + '/list'
                    } else {
                        route = '/surveys/global/' + survey.get('category').get('slug') + '/' + survey.get('class_name').slice(5) + '/list'
                    }
                } else {
                    if (survey.get('category').get('department')) {

                        route = '/surveys/' + survey.get('category').get('department').get('slug') + '/' + survey.get('category').get('slug') + '/form/' + survey.id
                    } else {
                        route = '/surveys/global/' + survey.get('category').get('slug') + '/form/' + survey.id
                    }
                }

                return route
            },

            navigate(route) {
                this.$router.push(route);
            },

            async needsMyApprovalSurveys(pageNumber) {
                let q = new Parse.Query('Form')
                q.select("status", "label_english", "label_pashto", "label_dari", "createdBy", "category", "class_name");
                q.include('createdBy')
                q.include('category')
                q.equalTo('type', 'survey')
                if (!this.user.get('roles').includes('survey-approver') && !this.user.get('roles').includes('survey-editor') && this.user.get('roles').includes('submitter')) {
                    // q.notEqualTo('status', 'pending')
                    q.equalTo('status', 'running')
                    q.equalTo('survey_submitters', this.user)
                } else {
                    q.equalTo('survey_design_approvers', this.user)
                    q.equalTo('survey_design_status', 'pending')
                }
                // q.skip((pageNumber - 1) * 10)
                // q.limit(10)
                let result = await q.find()
                this.allSurveysThatNeedsMyApproval = result
            },

            async needsMyApprovalSurveysCount() {
                let q = new Parse.Query('Form')
                q.equalTo('type', 'survey')

                if (!this.user.get('roles').includes('survey-approver') && !this.user.get('roles').includes('survey-editor') && this.user.get('roles').includes('submitter')) {
                    // q.notEqualTo('status', 'pending')
                    q.equalTo('status', 'running')
                    q.equalTo('survey_submitters', this.user)
                } else {
                    q.equalTo('survey_design_approvers', this.user)
                    q.equalTo('survey_design_status', 'pending')
                }

                let result = await q.count()
                this.allSurveysThatNeedsMyApprovalCount = result
            },

            async fetchPublishedSurveys(pageNumber) {
                let q = new Parse.Query('Form')
                q.select("status", "label_english", "label_pashto", "label_dari", "createdBy", "category", "class_name");
                q.include('createdBy')
                q.include('category')
                q.equalTo('type', 'survey')
                q.notEqualTo('status', 'pending')
                q.equalTo('survey_submission_approvers', this.user)
                // q.skip((pageNumber - 1) * 10)
                // q.limit(10)
                let result = await q.find()
                this.allPublishedSurveysThatNeedsMyApproval = result
            },

            async fetchPublishedSurveysCount() {
                let q = new Parse.Query('Form')
                q.equalTo('type', 'survey')
                q.notEqualTo('status', 'pending')
                q.equalTo('survey_submission_approvers', this.user)

                let result = await q.count()
                this.allPublishedSurveysThatNeedsMyApprovalCount = result
            }
        },

        async mounted() {
            if (this.user != null) {
                this.$store.commit("setLoading", true);
                await this.needsMyApprovalSurveysCount()
                await this.needsMyApprovalSurveys(1)
                if (!this.user.get('roles').includes('survey-editor') && !this.user.get('roles').includes('survey-approver') && this.user.get('roles').includes('submission-approver')) {
                    await this.fetchPublishedSurveysCount()
                    await this.fetchPublishedSurveys(1)
                }
                this.$store.commit("setLoading", false);
            }
        }
    }
</script>

<style>
    .category_avatar {
        padding: 30px 20px;
        border-radius: 2px;
        text-align: center;
        display: flex;
        justify-content: center;
        /* font-size: 2em; */
    }

    .category {
        background: #f4f5f7;
        color: #1f4688;
    }


    .category_wrapper {
        position: relative;
        display: inline-block;
        width: 100px;
        height: 100px;
        cursor: pointer;
        margin-right: 40px;
        margin-top: 20px;
        margin-bottom: 20px;
        text-align: center;
    }

    .category_wrapper_rtl {
        margin-left: 40px;
        margin-right: 0px;
    }

    .category_badge {
        position: absolute;
        right: -11px;
        top: -10px;
        width: 25px;
        height: 25px;
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
    }

    .category_name {
        width: 100px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        margin-top: 10px;
    }

    .approvalHead .headContent {
        color: #026a !important;
    }

    .approvalHead {
        color: #026a !important;
        /* font-size: 0.8em; */
        font-weight: normal;
        text-transform: uppercase;
        background: #0bf1;
        border: 2px solid #07f7 !important;
        border-bottom: none !important;
        margin-bottom: 0px !important;
        padding: 1px 12px;
        display: inline-block;
    }

    .approvalTable {
        margin-top: 0px !important;

    }

    .approvalTable td {
        max-width: 100px !important;
        overflow: hidden;
        text-overflow: ellipsis
    }
</style>